var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 8.01221C1.75 5.94114 3.42893 4.26221 5.5 4.26221H19.5C21.5711 4.26221 23.25 5.94114 23.25 8.01221V18.9997C23.25 21.0708 21.5711 22.7497 19.5 22.7497H5.5C3.42893 22.7497 1.75 21.0708 1.75 18.9997V8.01221ZM5.5 5.76221C4.25736 5.76221 3.25 6.76957 3.25 8.01221V18.9997C3.25 20.2423 4.25736 21.2497 5.5 21.2497H19.5C20.7426 21.2497 21.75 20.2423 21.75 18.9997V8.01221C21.75 6.76957 20.7426 5.76221 19.5 5.76221H5.5Z",
    fill: "#FB7C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.24974C7.91421 1.2496 8.25011 1.58527 8.25026 1.99949L8.25128 5.01223C8.25143 5.42644 7.91575 5.76235 7.50154 5.76249C7.08733 5.76263 6.75143 5.42696 6.75128 5.01274L6.75026 2C6.75011 1.58579 7.08579 1.24989 7.5 1.24974Z",
    fill: "#FB7C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1.25C17.9142 1.25 18.25 1.58579 18.25 2V4.63158C18.25 5.04579 17.9142 5.38158 17.5 5.38158C17.0858 5.38158 16.75 5.04579 16.75 4.63158V2C16.75 1.58579 17.0858 1.25 17.5 1.25Z",
    fill: "#FB7C2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 9.36816C5.75 8.95395 6.08579 8.61816 6.5 8.61816L18.5 8.61817C18.9142 8.61817 19.25 8.95395 19.25 9.36817C19.25 9.78238 18.9142 10.1182 18.5 10.1182L6.5 10.1182C6.08579 10.1182 5.75 9.78238 5.75 9.36816Z",
    fill: "#FB7C2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8fa75bb5714a8ba9f6d259c2d2df378d.svg";
export { ForwardRef as ReactComponent };